import * as React from 'react'
import { useMemo, useReducer } from 'react'
import { init } from './reducer/init'
import type { InitArg } from './reducer'
import { reducer } from './reducer/reducer'
import { SchedulingDrawer } from '../SchedulingDrawer'
import { SchedulingWizardContext } from './schedulingWizardContext'
import {
  SchedulingWizardCallbacksContext,
  type SchedulingWizardCallbacks,
} from './schedulingWizardCallbacks'

type Props = InitArg &
  SchedulingWizardCallbacks & {
    children: React.ReactNode
  }

export function SchedulingWizardContextProvider(props: Props) {
  const { children, onLeadAutoClosed, ...rest } = props

  const value = useReducer(reducer, rest, init)

  const callbacks = useMemo<SchedulingWizardCallbacks>(
    () => ({ onLeadAutoClosed }),
    [onLeadAutoClosed],
  )

  return (
    <SchedulingWizardContext.Provider value={value}>
      <SchedulingWizardCallbacksContext.Provider value={callbacks}>
        {children}
        <SchedulingDrawer />
      </SchedulingWizardCallbacksContext.Provider>
    </SchedulingWizardContext.Provider>
  )
}
